import React from 'react';
import { R400 } from '@atlaskit/theme/colors';
var AKLabel = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Label
    };
  });
});
export var Label = function Label(_ref) {
  var isRequired = _ref.isRequired,
    label = _ref.label,
    name = _ref.name;
  return /*#__PURE__*/React.createElement(AKLabel, {
    htmlFor: name,
    id: "".concat(name, "-label")
  }, label, isRequired && /*#__PURE__*/React.createElement("span", {
    style: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      paddingLeft: "var(--ds-space-025, 2px)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      color: "var(--ds-text-danger, ".concat(R400, ")")
    },
    "aria-hidden": "true"
  }, "*"));
};